import { render, staticRenderFns } from "./PaintIcon.vue?vue&type=template&id=83e4099a&"
import script from "./PaintIcon.vue?vue&type=script&lang=ts&"
export * from "./PaintIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports